import { Stack, Inline } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import { LinkButton } from '@atlaskit/button/new';
import ListExample from "../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/list";
import BoardExample from "../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/board";
import GridExample from "../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/grid";
import TableExample from "../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/table";
import FileExample from "../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/file";
import DrawingExample from "../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/drawing";
import ResizingExample from "../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/resizing";
import TreeExample from "../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/tree";
import TreeLegacyExample from "../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/tree-legacy";
import VirtualListExample from "../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/virtual-list";
import { TrelloLikeBoardIframe } from "../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/trello-like-board-iframe";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHlist from "!!raw-loader!../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/list";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHboard from "!!raw-loader!../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/board";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHgrid from "!!raw-loader!../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/grid";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHtable from "!!raw-loader!../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/table";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHfile from "!!raw-loader!../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/file";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHdrawing from "!!raw-loader!../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/drawing";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHresizing from "!!raw-loader!../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/resizing";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHtree from "!!raw-loader!../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/tree";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHtree_legacy from "!!raw-loader!../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/tree-legacy";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHvirtual_list from "!!raw-loader!../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/virtual-list";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHtrello_like_board_iframe from "!!raw-loader!../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/trello-like-board-iframe";
import * as React from 'react';
export default {
  Stack,
  Inline,
  SectionMessage,
  LinkButton,
  ListExample,
  BoardExample,
  GridExample,
  TableExample,
  FileExample,
  DrawingExample,
  ResizingExample,
  TreeExample,
  TreeLegacyExample,
  VirtualListExample,
  TrelloLikeBoardIframe,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHlist,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHboard,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHgrid,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHtable,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHfile,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHdrawing,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHresizing,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHtree,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHtree_legacy,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHvirtual_list,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHtrello_like_board_iframe,
  React
};